import React from 'react';
import { Alert } from '../../services/alertService';

interface TelegramPreviewProps {
  alerts: Alert[];
}

export function TelegramPreview({ alerts }: TelegramPreviewProps) {
  // סינון: לוקחים רק אלרטים שבאמת נשלחו בהצלחה לטלגרם
  const successfulTelegramAlerts = (alerts || []).filter((alert) => {
    const deliveries = (Array.isArray((alert as any).alert_deliveries)
      ? (alert as any).alert_deliveries
      : []) as any[];

    return deliveries.some(
      (delivery: any) =>
        delivery.channel?.toLowerCase() === 'telegram' &&
        delivery.status === 'sent'
    );
  });

  // אם אין אף התראה שנשלחה בהצלחה לטלגרם - מציגים הודעת ברירת מחדל
  if (successfulTelegramAlerts.length === 0) {
    return (
      <div className="rounded-2xl border border-gray-200 dark:border-[#1d2d47] bg-gray-50 dark:bg-[#0e1624] p-8 text-center shadow-sm">
        <p className="text-xs text-gray-500 dark:text-[#a3b6cc] leading-relaxed italic">
          בחר התראה שהופעלה ונשלחה בהצלחה לטלגרם כדי לראות את התצוגה המקדימה החיה שלה.
        </p>
      </div>
    );
  }

  return (
    <div className="rounded-2xl border border-gray-200 dark:border-[#1d2d47] bg-white dark:bg-[#0b111e] shadow-sm overflow-hidden text-left">

      {/* כותרת החלונית */}
      <div className="bg-gray-50 dark:bg-[#0e1624] px-4 py-2.5 border-b border-gray-200 dark:border-[#1d2d47] flex items-center gap-2">
        <span className="text-[10px] uppercase tracking-wider font-bold text-gray-500 dark:text-gray-400">
          TELEGRAM PREVIEW
        </span>
        <span className="text-[10px] text-gray-400 dark:text-gray-500 font-normal">
          how triggered alerts arrive
        </span>
      </div>

      {/* אזור ההודעות של הבוט */}
      <div className="p-4 space-y-4 max-h-[380px] overflow-y-auto no-scrollbar">

        {/* פרופיל הבוט */}
        <div className="flex items-center gap-2.5 mb-1">
          <div className="w-8 h-8 rounded-full bg-blue-500 flex items-center justify-center text-white font-bold text-sm select-none">
            D
          </div>
          <div>
            <div className="text-xs font-bold text-gray-900 dark:text-gray-200">CatalystIQ</div>
            <div className="text-[10px] text-gray-500">bot</div>
          </div>
        </div>

        {/* רשימת הודעות האיתותים */}
        <div className="space-y-2">
          {[...successfulTelegramAlerts]
            .sort((a, b) => new Date(a.triggered_at || 0).getTime() - new Date(b.triggered_at || 0).getTime())
            .slice(-3)
            .reverse()
            .map((alert) => {
              const timeString = alert.triggered_at
                ? new Date(alert.triggered_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })
                : new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

              return (
                <div
                  key={alert.id}
                  className="bg-gray-50 dark:bg-[#141f32] rounded-xl p-3 border border-gray-200 dark:border-gray-800/60 relative space-y-1"
                >
                  <div className="text-xs font-bold text-blue-600 dark:text-blue-400 flex items-center gap-1">
                    ⚡ {alert.ticker}
                  </div>

                  <p className="text-[11px] text-gray-600 dark:text-gray-300">
                    Alert <span className="font-semibold text-gray-900 dark:text-white">{alert.alert_type}</span> triggered.
                  </p>

                  <p className="text-[11px] text-gray-600 dark:text-gray-300">
                    Price <span className="font-bold text-gray-900 dark:text-white">${Number(alert.target_value ?? 0).toLocaleString()}</span>
                  </p>

                  <span className="absolute bottom-1 right-2.5 text-[9px] text-gray-400 dark:text-gray-500 font-mono">
                    {timeString}
                  </span>
                </div>
              );
            })}
        </div>

      </div>
    </div>
  );
}
